import actions from "./actions";

let items, idx;

const initState = {
    items: [],
    pagination: {},
    showPagination: false,

    item: null,
    activeItemId: null,
    itemStatus: null,
    readItemsState: null,
    readItemState: null,
    deleteItemState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.SHOEBOX_READ_ITEMS_REQUEST:
            return {
                ...state,
                readItemsState: 'request',
            };
        case actions.SHOEBOX_READ_ITEMS_SUCCESS:
            return {
                ...state,
                readItemsState: 'success',
                items: action.shoeboxItems,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                showPagination: action.pagination.total > action.pagination.per_page,
            };
        case actions.SHOEBOX_READ_ITEM_REQUEST:
            return {
                ...state,
                readItemState: 'request',
            };
        case actions.SHOEBOX_READ_ITEM_SUCCESS:
            return {
                ...state,
                readItemState: 'success',
                item: action.shoeboxItem,
                // // TO SIMULATE PREPOLUATE CONTACTS in SHOEBOX
                // item: {
                //     ...action.shoeboxItem,
                //     file: {
                //         ...action.shoeboxItem.file,
                //         data: {
                //             ...action.shoeboxItem.file.data,
                //             contacts: [
                //                 ...action.shoeboxItem.file.data.contacts,
                //                 "Banksy AUD",
                //             ],
                //         },
                //     },
                // },
            };
        case actions.SHOEBOX_DELETE_ITEM_REQUEST:
            return {
                ...state,
                deleteItemState: 'request',
            };
        case actions.SHOEBOX_DELETE_ITEM_SUCCESS:
            return {
                ...state,
                deleteItemState: 'success',
            };
        case actions.SHOEBOX_ADD_LIST_ITEM: { // Add to the end, ignore if already in the list.
            idx = state.items.findIndex(item => item.id === action.item.id);
            if (idx !== -1) // Found, ignore
                return state;

            const items = [
                ...state.items,
                action.item,
            ];

            const {pageSize, current, total} = state.pagination;
            const newTotal = total + 1;

            const newPagination = {
                ...state.pagination,
                total: newTotal,
                current: (newTotal / pageSize) > current ? current + 1 : current,
            };

            return {
                ...state,
                items,
                pagination: newPagination,
                showPagination: newTotal > pageSize,
            };
        }
        case actions.SHOEBOX_SET_LIST_ITEM: // Update item by id.
            items = [...state.items];
            idx = items.findIndex(item => item.id === action.item.id);
            items[idx] = action.item;

            return {
                ...state,
                items,
            };
        case actions.SHOEBOX_REMOVE_LIST_ITEM: { // Remove by id, ignore if missing.
            items = [...state.items];
            idx = items.findIndex(item => item.id === action.id);
            if (idx !== -1) // Found
                items.splice(idx, 1);

            const { total, current, pageSize } = state.pagination;
            const newTotal = total - 1;

            const newPagination = {
                ...state.pagination,
                total: newTotal,
                current: (newTotal % pageSize === 0) ? current - 1 : current,
            };

            return {
                ...state,
                items,
                pagination: newPagination,
                showPagination: newTotal > pageSize,
            };
        }
        case actions.SHOEBOX_SET_ITEM: // Support partial
            return {
                ...state,
                item: {
                    ...state.item,
                    ...action.item,
                },
            };
        case actions.SHOEBOX_SET_ACTIVE_ITEM_ID:
            return {
                ...state,
                activeItemId: action.id,
            };
        case actions.SHOEBOX_SET_ITEM_STATUS:
            return {
                ...state,
                itemStatus: action.status,
            };
        case actions.SHOEBOX_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
